export type DeployDTO = {
  machineId: string
  acknowledgementText?: string
  positions: number[]
}

export type JobDTO = {
  orderNumber: string
  rid: string
  deployedOn: DeployDTO[]
}
export type CreateAssignmentDTO = DeployDTO & {
  orderNumber: string
  rid: string
}

export type AssignmentResultDTO = {
  id: string
  assignmentFinished: boolean
  error: string
  successfulPositions: number[]
  failedPositions: number[]
}

export enum AssignmentStatus {
  Expired = 'Expired',
  Failed = 'Failed',
  AssignmentInProgress = 'AssignmentInProgress',
  Success = 'Success'
}

export type AssignmentDTO = AssignmentResultDTO & {
  machineId: string
  orderNumber: string
  status?: AssignmentStatus
  successfulPositions: number[]
  failedPositions: number[]
  assignmentError?: string
  createdAt?: string
  processedByMachineAt?: string
  rid: string
  recipeVersionId?: string
  error: string
}

export type ResponseDTO<T> = {
  result: T[]
  skip: number
  take: number
  count: number
}
